import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {ErrorLabel} from '../../models/error-label.model';

@Component({
  selector: 'app-error-label',
  templateUrl: './error-label.component.html',
  styleUrls: ['./error-label.component.scss']
})
export class ErrorLabelComponent implements OnInit {

  @Input() control: AbstractControl | FormControl;
  @Input() errors: Array<ErrorLabel>;

  constructor() {
  }

  ngOnInit(): void {
  }

}
